import { Room } from '@graphql/Room/queries/get-room.graphql';
import { IUser } from '@models/User/i-user';

/**
 * Returns `true` if a user is considered HVC.
 * @param user User
 * @param room If defined, checks HVC conditions for that specific room. If not defined,
 * it considers room agnostic HVC conditions.
 */
export default function useIsHighValueCustomer(
  user?: IUser | null,
  room?: Room,
) {
  const isHVC = room ? room?.roomProfile?.isHighValueRoom : user?.isHVC;

  return {
    isHighValueCustomer: isHVC || false
  };
}
